import React from 'react';
import { CouponStatusBadge } from './CouponStatusBadge';
import { CouponRowActions } from './CouponRowActions';
import {
  formatExpiresAt,
  formatAppliesTo,
  formatDiscount,
} from '../utils';

export const columns = [
  {
    name: <span className="sr-only">Opções</span>,
    selector: (row) => row.id,
    width: '56px',
    center: true,
    cell: (row) => <CouponRowActions coupon={row} />,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  {
    name: 'Nome cupom',
    selector: (row) => row.code,
    minWidth: '120px',
    cell: (row) => (
      <code
        className="items-cell--code items-cell--truncate"
        title={row.code || '-'}
      >
        {row.code || '-'}
      </code>
    ),
  },
  {
    name: 'Data de expiração',
    selector: (row) => row.expiresAt,
    cell: (row) => <div>{formatExpiresAt(row.expiresAt)}</div>,
    width: '180px',
    sortable: true,
    grow: 1.5,
  },
  {
    name: 'Status',
    cell: (row) => <CouponStatusBadge coupon={row} />,
    width: '120px',
  },
  {
    name: 'Desconto',
    selector: (row) => formatDiscount(row),
    width: '130px',
  },
  {
    name: 'Aplicável em',
    selector: (row) => formatAppliesTo(row),
    minWidth: '160px',
    grow: 1.5,
  },
];
